import {CHANGE_SUC_SHOW} from '../actions/medicalExamRreport';

const initState = {
  sucShow: true
};


export default (state = initState, action) => {
  switch (action.type) {
    case CHANGE_SUC_SHOW: {
      return Object.assign({}, state, {
        sucShow: false
      });
    }
    default:
      return state;
  }
};


// WEBPACK FOOTER //
// ./src/reducers/medicalExamRreport.js